export const INACTIVITY_LIMIT = 15 * 60 * 1000; // 15 minutes
export const CHECK_INACTIVITY_INTERVAL = 15 * 1000; // 15 seconds
export const ACTIVITY_EVENTS_THROTTLE = 1 * 1000; // 1 second
export const LAST_ACTIVITY_STORAGE_KEY = 'app-last-activity-time';
export const REFRESH_EVENT_KEY = 'refresh-signal';

export const ACTIVITY_EVENTS = ['mousemove', 'keydown', 'scroll', 'click', 'touchstart'];
